// ABA routing-number checksum, shared with api_ach_vault's server-side check
// (plan §4) for inline UX feedback only — the vault is the enforcement point.
// (3(d1+d4+d7) + 7(d2+d5+d8) + (d3+d6+d9)) mod 10 == 0
const FORMAT = /^[0-9]{9}$/;

export function isValidRoutingNumber(value) {
  if (typeof value !== "string" || !FORMAT.test(value)) return false;
  if (value === "000000000") return false;

  const d = value.split("").map(Number);
  const checksum =
    3 * (d[0] + d[3] + d[6]) + 7 * (d[1] + d[4] + d[7]) + (d[2] + d[5] + d[8]);
  return checksum % 10 === 0;
}
